/**
 * 통화 활성 상태 공유 모듈 (순수 JS, React 비의존)
 * - 통화 중 화면 지연 로딩 실패 시 새로고침 보류 등에 사용
 */

let isCallActiveState = false;
const idleListeners = new Set();

/**
 * 통화 활성 여부 설정
 * @param {boolean} active 
 */
export function setCallActive(active) {
  const next = Boolean(active);
  if (isCallActiveState === next) return;
  isCallActiveState = next;

  if (!isCallActiveState) {
    const listeners = Array.from(idleListeners);
    idleListeners.clear();
    for (const cb of listeners) {
      try {
        cb();
      } catch (err) {
        console.warn('[callActivity] onCallIdle 콜백 오류:', err);
      }
    }
  }
}

/**
 * 현재 통화 활성 여부 반환
 * @returns {boolean}
 */
export function isCallActive() {
  return isCallActiveState;
}

/**
 * 통화가 idle(비활성)이 될 때 1회 호출할 콜백 등록
 * 이미 idle인 경우 다음 틱에 즉시 호출
 * @param {() => void} cb 
 * @returns {() => void} 등록 해제 함수
 */
export function onCallIdle(cb) {
  if (typeof cb !== 'function') return () => {};

  if (!isCallActiveState) {
    const timer = setTimeout(() => {
      try {
        cb();
      } catch (err) {
        console.warn('[callActivity] onCallIdle 콜백 오류:', err);
      }
    }, 0);
    return () => clearTimeout(timer);
  }

  idleListeners.add(cb);
  return () => {
    idleListeners.delete(cb);
  };
}
